import { getJson, post } from "../helpers/request";
import { LoginData } from "../types/common";

export const getLoginData = async (): Promise<LoginData> => {
  const response = await getJson<{
    residenceInFinland?: boolean;
    userId: string;
  }>({
    url: __LOGIN_API + "/v1/user/login",
    withCredentials: true
  });
  return {
    loggedIn: true,
    residenceInFinland: !!response.residenceInFinland,
    userId: response.userId
  };
};

export const createTemporaryLoginToken = async (
  isLoggedIn: boolean
): Promise<string> => {
  if (!isLoggedIn) {
    return "";
  }

  return post<{
    token: string;
  }>({
    url: __LOGIN_API + "/v1/user/session/temp",
    withCredentials: true
  })
    .then(response => response.token)
    .catch(() => "");
};
